import { Option } from "@familyzone/component-library";

export const portOptions = (): Option[] => {
  const list = [];
  for (let i = 0; i < 65537; i++) list.push({ value: i });
  return list;
};
